export class MyPayRequest {
  transactionId: string;
  transactionAmount: number;

  constructor(transactionId: string, transactionAmount: number) {
    this.transactionId = transactionId;
    this.transactionAmount = transactionAmount;
  }
}
